export default "__VITE_ASSET__Bh7Dp1nV__"